import React from "react";
import { Link } from "react-router-dom";
import Searchbox2 from "../Searchbox2";
import Dashboard1 from "../Dashboard1";
import Group85 from "../Group85";
import X013 from "../X013";
import ButtonWithdrawAllEarning3 from "../ButtonWithdrawAllEarning3";
import Group682 from "../Group682";
import Group100 from "../Group100";
import DueDate2 from "../DueDate2";
import Group1032 from "../Group1032";
import X3 from "../X3";
import "./TabletDashboard.css";

function TabletDashboard(props) {
  const {
    icon,
    profile,
    path71,
    menu,
    proposal,
    users,
    welcome,
    plunderdesignComXxxxxxx,
    iconStar1,
    x5Per1Spent,
    onPersonalReferr,
    path51,
    path52,
    path53,
    path54,
    bonusRewards,
    forEvery200InPurchases,
    path59,
    path60,
    path61,
    path62,
    path63,
    levelUp,
    achieveAffiliateEarn10Per1,
    learnMore,
    rectangle29,
    activityLogs1,
    availablePoints,
    number1,
    overlapGroup1,
    available50OffCoupons,
    overlapGroup2,
    exclusiveItemAccess,
    group96,
    number2,
    overlapGroup13,
    activityLogs2,
    overlapGroup10,
    yourImageHere1,
    sleepangle1,
    overlapGroup,
    explore,
    ongoing1,
    justIn,
    overlapGroup11,
    yourImageHere2,
    sleepangle2,
    overlapGroup3,
    subscribe,
    posseBox,
    ongoing2,
    rightbar,
    address1,
    number3,
    address2,
    schedule,
    thursdayJanuary10Th2022,
    meetingWithClient,
    x10001100,
    activityLogs3,
    rectangle311,
    path641,
    iconStar2,
    price1,
    price2,
    x25AwayFrom10BonusPoints1,
    activityLogs4,
    rectangle312,
    path642,
    iconLabel,
    price3,
    price4,
    x25AwayFrom10BonusPoints2,
    activityLogs5,
    activityLogs6,
    rectangle313,
    path643,
    iconHeart,
    price5,
    price6,
    x25AwayFrom10BonusPoints3,
    activityLogs7,
    rectangle314,
    rectangle32,
    iconGift1,
    rectangle34,
    x12Months,
    path644,
    iconGift2,
    x20BonusPoints,
    x30BonusPoints,
    x50BonusPoints,
    x75BonusPointsGifts,
    x9Months,
    x6Months,
    x3Months,
    address3,
    searchbox2Props,
    dashboard1Props,
    group85Props,
    group6821Props,
    group6822Props,
    buttonWithdrawAllEarning3Props,
    x31Props,
    x32Props,
    group1032Props,
    x33Props,
  } = props;

  return (
    <div className="container-center-horizontal">
      <div className="tablet-dashboard screen">
        <div className="overlap-group16">
          <div className="nav-1">
            <Searchbox2 search2Props={searchbox2Props.search2Props} />
            <div className="separator-2"></div>
            <Link to="/tablet-menu">
              <div className="profile-9">
                <div className="group-122">
                  <img className="icon-7" src={icon} />
                </div>
                <div
                  className="profile-10"
                  style={{ backgroundImage: `url(${profile})` }}
                ></div>
              </div>
            </Link>
          </div>
          <div className="sidebar">
            <div className="header-5">
              <div className="overlap-group1-24">
                <img className="path-71" src={path71} />
              </div>
            </div>
            <div className="menus-4">
              <div className="menu opensans-bold-cloud-16px">{menu}</div>
              <div className="dashboard-9">
                <Dashboard1
                  dashboard1={dashboard1Props.dashboard1}
                  className={dashboard1Props.className}
                />
              </div>
              <Link to="/tablet-my-connections-ecwid-social-connect-dashboard">
                <div className="email-1">
                  <div
                    className="proposal-4"
                    style={{ backgroundImage: `url(${proposal})` }}
                  ></div>
                </div>
              </Link>
              <Link to="/tablet-my-account">
                <div className="group-121">
                  <div
                    className="users"
                    style={{ backgroundImage: `url(${users})` }}
                  ></div>
                </div>
              </Link>
              <Link to="/tablet-my-reports-distributers-only">
                <div className="group-95">
                  <Group85
                    path69={group85Props.path69}
                    path70={group85Props.path70}
                    className={group85Props.className}
                  />
                </div>
              </Link>
            </div>
          </div>
          <div className="content-2">
            <div className="flex-col-3">
              <div className="overlap-group14">
                <div className="welcome-2 opensans-normal-quick-silver-12px">
                  {welcome}
                </div>
                <div className="overlap-group9">
                  <div className="group-91 border-0-5px-dove-gray">
                    <div className="plunderdesigncomxxxxxxx-2 avenir-medium-black-10px">
                      {plunderdesignComXxxxxxx}
                    </div>
                  </div>
                  <X013 />
                </div>
              </div>
              <div className="group-87">
                <div className="group-79-2">
                  <img className="icon-star-2" src={iconStar1} />
                  <div className="x5-per-1-spent-2 avenir-heavy-normal-eerie-black-10px">
                    {x5Per1Spent}
                  </div>
                  <p className="on-personal-referr-2 avenir-book-normal-eerie-black-6px">
                    {onPersonalReferr}
                  </p>
                </div>
                <div className="group-80-2">
                  <div className="group-64-2">
                    <div className="path-container-12">
                      <img className="path-51-2" src={path51} />
                      <img className="path-52-2" src={path52} />
                      <img className="path-53-2" src={path53} />
                      <img className="path-54-2" src={path54} />
                    </div>
                  </div>
                  <div className="bonus-rewards-2 avenir-heavy-normal-eerie-black-10px">
                    {bonusRewards}
                  </div>
                  <p className="for-every-200-in-purchases-2 avenir-book-normal-eerie-black-6px">
                    {forEvery200InPurchases}
                  </p>
                </div>
                <div className="group-70-2">
                  <div className="group-81-2">
                    <div className="group-69-2">
                      <img className="path-59-2" src={path59} />
                      <img className="path-60-2" src={path60} />
                      <img className="path-61-2" src={path61} />
                      <div className="path-container-13">
                        <img className="path-62-2" src={path62} />
                        <img className="path-63-2" src={path63} />
                      </div>
                    </div>
                    <div className="level-up-2 avenir-heavy-normal-eerie-black-10px">
                      {levelUp}
                    </div>
                    <p className="achieve-affiliate-earn-10-per-1-2 avenir-book-normal-eerie-black-6px">
                      {achieveAffiliateEarn10Per1}
                    </p>
                    <div className="learn-more-6">{learnMore}</div>
                  </div>
                </div>
              </div>
              <div className="overlap-group12">
                <img className="rectangle-29-2" src={rectangle29} />
                <div className="activity-logs-8 avenir-heavy-normal-eerie-black-12px">
                  {activityLogs1}
                </div>
              </div>
              <div className="overview">
                <div className="card-rewards-2">
                  <div className="earning-report-4">
                    <div className="text-earning-this-month-8">
                      <div className="available-points-2 avenir-book-normal-log-cabin-10px">
                        {availablePoints}
                      </div>
                      <div className="overlap-group-49">
                        <div className="number-6">{number1}</div>
                        <ButtonWithdrawAllEarning3 />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-share-link">
                  <div
                    className="overlap-group1-25"
                    style={{ backgroundImage: `url(${overlapGroup1})` }}
                  >
                    <div className="share-link-4">
                      <div className="text-earning-this-month-9">
                        <div className="group-1-5">
                          <div className="available-50-off-coupons-2 avenir-book-normal-log-cabin-10px">
                            {available50OffCoupons}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="group-container-4">
                      <Group682 />
                      <Group682 className={group6821Props.className} />
                      <Group682 className={group6822Props.className} />
                    </div>
                  </div>
                </div>
                <div className="card-share-link">
                  <div
                    className="overlap-group2-12"
                    style={{ backgroundImage: `url(${overlapGroup2})` }}
                  >
                    <div className="share-link-5">
                      <div className="text-earning-this-month-10">
                        <div className="group-1-6">
                          <div className="exclusive-item-access-2 avenir-book-normal-log-cabin-10px">
                            {exclusiveItemAccess}
                          </div>
                          <div
                            className="group-96"
                            style={{ backgroundImage: `url(${group96})` }}
                          >
                            <div className="number-7">{number2}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ButtonWithdrawAllEarning3
                      className={buttonWithdrawAllEarning3Props.className}
                    />
                  </div>
                </div>
              </div>
              <div
                className="overlap-group13"
                style={{ backgroundImage: `url(${overlapGroup13})` }}
              >
                <p className="activity-logs-9 avenir-heavy-normal-eerie-black-12px">
                  {activityLogs2}
                </p>
              </div>
              <div className="overlap-group-container">
                <div
                  className="overlap-group10"
                  style={{ backgroundImage: `url(${overlapGroup10})` }}
                >
                  <div className="overlap-group1-26">
                    <img className="your-image-here-8" src={yourImageHere1} />
                    <img className="sleepangle-8" src={sleepangle1} />
                    <div className="group-25-8">
                      <div
                        className="overlap-group-50"
                        style={{ backgroundImage: `url(${overlapGroup})` }}
                      >
                        <div className="explore-4">{explore}</div>
                      </div>
                    </div>
                    <div className="ongoing-8 avenir-book-normal-black-12px">
                      {ongoing1}
                    </div>
                  </div>
                  <div className="just-in-4 bodoni72-bold-eerie-black-22px">
                    {justIn}
                  </div>
                </div>
                <div
                  className="overlap-group11"
                  style={{ backgroundImage: `url(${overlapGroup11})` }}
                >
                  <img className="your-image-here-9" src={yourImageHere2} />
                  <img className="sleepangle-9" src={sleepangle2} />
                  <div className="group-25-9">
                    <div
                      className="overlap-group-51"
                      style={{ backgroundImage: `url(${overlapGroup3})` }}
                    >
                      <div className="subscribe-4">{subscribe}</div>
                    </div>
                  </div>
                  <div className="posse-box-4 bodoni72-bold-eerie-black-22px">
                    {posseBox}
                  </div>
                  <p className="ongoing-9 avenir-book-normal-black-12px">
                    {ongoing2}
                  </p>
                </div>
              </div>
            </div>
            <div
              className="rightbar-2"
              style={{ backgroundImage: `url(${rightbar})` }}
            >
              <div className="text-earning-this-month-11">
                <div className="group-12">
                  <div className="address-6">{address1}</div>
                  <div className="overlap-group-52">
                    <div className="number-8 bodoni72-bold-black-43px">
                      {number3}
                    </div>
                    <p className="address-7">{address2}</p>
                  </div>
                </div>
              </div>
              <div className="title-4">
                <div className="schedule-4 avenir-black-eerie-black-24px">
                  {schedule}
                </div>
                <div className="thursday-january-10th-2022-2 montserrat-medium-quick-silver-16px">
                  {thursdayJanuary10Th2022}
                </div>
              </div>
              <div className="group-container-5">
                <div className="group-101">
                  <Group100 />
                  <div className="overlap-group1-27">
                    <DueDate2 />
                    <div className="group-99">
                      <div className="meeting-with-client-4 avenir-black-eerie-black-16px">
                        {meetingWithClient}
                      </div>
                      <div className="x1000-1100-10 manrope-extra-bold-bizarre-10px">
                        {x10001100}
                      </div>
                    </div>
                  </div>
                </div>
                <Group1032 />
              </div>
              <div className="overlap-group7-2">
                <div className="line"></div>
                <X3
                  group100Props={x31Props.group100Props}
                  date2Props={x31Props.date2Props}
                />
                <X3
                  group100Props={x32Props.group100Props}
                  date2Props={x32Props.date2Props}
                />
              </div>
              <Group1032 className={group1032Props.className} />
              <X3
                className={x33Props.className}
                group100Props={x33Props.group100Props}
                date2Props={x33Props.date2Props}
              />
            </div>
          </div>
          <div className="activity-logs-10 avenir-heavy-normal-eerie-black-18px">
            {activityLogs3}
          </div>
          <div className="rectangle-36"></div>
          <div className="group-78-2">
            <div className="group-72-2">
              <div className="overlap-group-47">
                <div className="overlap-group-48">
                  <img className="rectangle-31-6" src={rectangle311} />
                  <div className="rectangle-32-10 border-2px-dove-gray"></div>
                  <img className="path-64-4" src={path641} />
                  <img className="icon-star-3" src={iconStar2} />
                </div>
                <div className="price-6 avenir-heavy-normal-white-19px">
                  {price1}
                </div>
                <div className="price-7 avenir-heavy-normal-sonic-silver-12px">
                  {price2}
                </div>
                <p className="x25-away-from-10-bonus-points-4 avenir-book-normal-sonic-silver-11px">
                  {x25AwayFrom10BonusPoints1}
                </p>
              </div>
              <div className="activity-logs-7 avenir-heavy-normal-eerie-black-20px">
                {activityLogs4}
              </div>
            </div>
            <div className="group-73-2">
              <div className="overlap-group-47">
                <div className="overlap-group-48">
                  <img className="rectangle-31-6" src={rectangle312} />
                  <div className="rectangle-32-11 border-2px-dove-gray"></div>
                  <img className="path-64-4" src={path642} />
                  <img className="icon-label-2" src={iconLabel} />
                </div>
                <div className="price-6 avenir-heavy-normal-white-19px">
                  {price3}
                </div>
                <div className="price-7 avenir-heavy-normal-sonic-silver-12px">
                  {price4}
                </div>
                <p className="x25-away-from-10-bonus-points-4 avenir-book-normal-sonic-silver-11px">
                  {x25AwayFrom10BonusPoints2}
                </p>
              </div>
              <div className="activity-logs-7 avenir-heavy-normal-eerie-black-20px">
                {activityLogs5}
              </div>
            </div>
            <div className="group-75-2">
              <div className="overlap-group3-8">
                <div className="activity-logs-7 avenir-heavy-normal-eerie-black-20px">
                  {activityLogs6}
                </div>
                <div className="overlap-group-47">
                  <div className="overlap-group-48">
                    <img className="rectangle-31-6" src={rectangle313} />
                    <div className="rectangle-32-12 border-2px-dove-gray"></div>
                    <img className="path-64-4" src={path643} />
                    <img className="icon-heart-1" src={iconHeart} />
                  </div>
                  <div className="price-6 avenir-heavy-normal-white-19px">
                    {price5}
                  </div>
                  <div className="price-7 avenir-heavy-normal-sonic-silver-12px">
                    {price6}
                  </div>
                  <p className="x25-away-from-10-bonus-points-4 avenir-book-normal-sonic-silver-11px">
                    {x25AwayFrom10BonusPoints3}
                  </p>
                </div>
              </div>
            </div>
            <div className="group-76-2">
              <div className="overlap-group4-8">
                <div className="activity-logs-7 avenir-heavy-normal-eerie-black-20px">
                  {activityLogs7}
                </div>
                <div className="group-74-2">
                  <div className="overlap-group2-13">
                    <div className="overlap-group-53">
                      <img className="rectangle-31-7" src={rectangle314} />
                      <img className="rectangle-32-13" src={rectangle32} />
                      <div className="rectangle-33-4 border-2px-dove-gray"></div>
                      <img className="icon-gift-2" src={iconGift1} />
                      <img className="rectangle-34-2" src={rectangle34} />
                      <div className="rectangle-35-2 border-1px-dove-gray"></div>
                    </div>
                    <div className="x12months-2 avenir-heavy-normal-sonic-silver-11px">
                      {x12Months}
                    </div>
                    <div className="group-77-2">
                      <div className="overlap-group1-28">
                        <div className="rectangle-31-8 border-2px-dove-gray"></div>
                        <div className="rectangle-32-14 border-2px-dove-gray"></div>
                        <div className="rectangle-33-5 border-2px-dove-gray"></div>
                        <img className="path-64-5" src={path644} />
                        <img className="icon-gift-3" src={iconGift2} />
                        <div className="x20bonus-points-2 avenir-heavy-normal-white-11px">
                          {x20BonusPoints}
                        </div>
                        <div className="x30bonus-points-2 avenir-heavy-normal-white-11px">
                          {x30BonusPoints}
                        </div>
                        <div className="x50bonus-points-2 avenir-heavy-normal-pale-sky-11px">
                          {x50BonusPoints}
                        </div>
                      </div>
                      <div className="x75bonus-points-gifts-2 avenir-heavy-normal-pale-sky-11px">
                        {x75BonusPointsGifts}
                      </div>
                    </div>
                    <div className="x9months-2 avenir-heavy-normal-sonic-silver-11px">
                      {x9Months}
                    </div>
                    <div className="x6months-2 avenir-heavy-normal-sonic-silver-11px">
                      {x6Months}
                    </div>
                    <div className="x3months-2 avenir-heavy-normal-sonic-silver-11px">
                      {x3Months}
                    </div>
                  </div>
                  <p className="address-8 avenir-book-normal-sonic-silver-11px">
                    {address3}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TabletDashboard;
